import * as React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import cx from 'classnames';
import style from './Button.css';

export const Button = ({className, children, ...rest}) => (
    <button className={cx(style.root, className)} {...rest}>
        {children}
    </button>
);

Button.propTypes = {
    className: PropTypes.string
};

export const ButtonLink = ({className, children, ...rest}) => (
    <Link className={cx(style.root, style.link, className)} {...rest}>
        {children}
    </Link>
);

export const ButtonRound = ({className, children, ...rest}) => (
    <Link className={cx(style.root, style.round, className)} {...rest}>
        {children}
    </Link>
);